import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FaqQuestion = ({ id, title, details, handleChange, expanded }) => {
  return (
    <Accordion
      elevation={0}
      variant="outlined"
      expanded={expanded}
      onChange={() => handleChange(id)}
      sx={{ borderRadius: 1 }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
      >
        <Typography component="h3" variant="subtitle2">
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Typography
          variant="body2"
          gutterBottom
          sx={{ maxWidth: { sm: '100%', md: '100%' } }}
        >
          {details}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
};
export default FaqQuestion;
